import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { logTermAction } from './useTermsOfUseLogs';

interface UpdateTermParams {
  termId: string;
  content: string;
  userId: string;
  userName: string;
}

export const useUpdateTerm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ termId, content, userId, userName }: UpdateTermParams) => {
      const { error } = await supabase
        .from('terms_of_use')
        .update({ content })
        .eq('id', termId)
        .eq('pending_activation', true);
      
      if (error) throw error;
      
      // Registrar log de edição
      await logTermAction({
        termId,
        action: 'edit',
        userId,
        userName
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['terms-of-use'] });
      toast.success('Termo salvo com sucesso');
    },
    onError: (error) => {
      console.error('Erro ao atualizar termo:', error);
      toast.error('Erro ao salvar o termo');
    }
  });
};
